import { Amplify } from "aws-amplify";
import { signIn } from "aws-amplify/auth";

// aws-exports.js
export const awsConfig = {
    Auth: {
        Cognito: {
            region: process.env.REACT_APP_REGION|| 'us-east-1',
            userPoolId: process.env.REACT_APP_ADMIN_COGNITO_USERPOOL_ID,
            userPoolClientId: process.env.REACT_APP_ADMIN_COGNITO_CLIENT_ID,
            identityPoolId: process.env.REACT_APP_ADMIN_COGNITO_IDENTITY_POOL_ID,
        }
    },
    Storage: {
        S3: {
            bucket: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_REGION|| 'us-east-1',
        }
    }
};

async function authenticateUser(username,password) {
    Amplify.configure(awsConfig)
    try {
    // Authenticate user using username/email and password
        const loginResponse = await signIn({ username, password, options: { authFlowType: 'USER_PASSWORD_AUTH' } });
    } catch (error) {
        console.error('Authentication Error:', error);
    }
}

export default authenticateUser;